module.exports = __webpack_public_path__ + "img/style_0_7.cdd870dd.png";